import axios from '../../../configs/axios';

export interface Release {
  id: string;
  releaseName: string;
  version: string;
  type: string;
  description?: string;
  downloadKey?: string;
  downloads: number;
  fileSize?: string;
  fileType?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateReleaseRequest {
  releaseName: string;
  version: string;
  type: string;
  description?: string;
  downloadKey?: string;
  fileSize?: string;
  fileType?: string;
}

export interface UpdateReleaseRequest extends Partial<CreateReleaseRequest> {}

export const releasesAPI = {
  getAllReleases: async (search?: string) => {
    const params = search ? { search } : {};
    const response = await axios.get('/admin/releases', { params });
    return response.data;
  },

  getReleaseById: async (id: string) => {
    const response = await axios.get(`/admin/releases/${id}`);
    return response.data;
  },

  createRelease: async (data: CreateReleaseRequest) => {
    const response = await axios.post('/admin/releases', data);
    return response.data;
  },

  updateRelease: async (id: string, data: UpdateReleaseRequest) => {
    const response = await axios.put(`/admin/releases/${id}`, data);
    return response.data;
  },

  deleteRelease: async (id: string) => {
    const response = await axios.delete(`/admin/releases/${id}`);
    return response.data;
  },

  downloadRelease: async (id: string) => {
    const response = await axios.post(`/admin/releases/${id}/download`);
    return response.data;
  }
};

export const s3API = {
  uploadFile: async (file: File, folder: string, name: string, version: string) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folder', folder);
    formData.append('name', name);
    formData.append('version', version);

    const response = await axios.post('/s3/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Convenience method for releases
  uploadReleaseFile: async (file: File, releaseName: string, version: string) => {
    return s3API.uploadFile(file, 'releases', releaseName, version);
  },

  // Convenience method for product sheets
  uploadProductSheetFile: async (file: File, sheetName: string, version: string) => {
    return s3API.uploadFile(file, 'sheets', sheetName, version);
  }
};
